<template>
  <div style="display: grid;place-items: center;user-select: none;">
    <div id="scroller" :style="{width:width}" ref="scroller">
      <div id="scroller-block" ref="scroller-block">
        <p class="numberInScroller" @click="scrollToValue(n)" :class="{'selected-value':val==n}" v-for="n in numbers" :key="n" :style="{width:widthOfOneColumn}">{{n}}</p>
      </div>
    </div>
    <div id="selectedValueIndicator" ref='selectedValueIndicator' :class="{'selected-indicator':!scrolling && !touch,'indicator-ios':scrolling || touch}"><span v-if="!scrolling && !touch" style="font-size: 2em;font-weight:600">{{val}}</span></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      widthOfOneColumn: 40,
      startNumber: 0,
      endNumber: 200,
      stepValue: 1,
      val: 0,
      scrollTimeout: null,
      touchTimeout: null,
      width: 360,
      numbers: [],
      scrolling: false,
      touch: false,
    };
  },
  props: ["start", "end", "step", "value"],
  mounted() {
    let that = this;
    if (this.start) {
      this.startNumber = this.start;
    }
    if (this.end) {
      this.endNumber = this.end;
    }
    if (this.step) {
      this.stepValue = this.step;
    }

    let z = this.startNumber;
    while (z < this.endNumber + this.stepValue) {
      this.numbers.push(z);
      let value = z + this.stepValue;
      z = Math.round(value * 100) / 100;
    }

    const scrollerBlock = this.$refs["scroller-block"];
    scrollerBlock.style.gridTemplateColumns =
      "repeat(" + this.numbers.length + ", " + this.widthOfOneColumn + "px)";
    scrollerBlock.style.paddingLeft = "" + this.widthOfOneColumn * 4 + "px";
    scrollerBlock.style.paddingRight =
      "" + this.widthOfOneColumn * 4 * (this.numbers.length / 2) + "px";

    const scroller = this.$refs.scroller;

    scroller.style.width = "" + 9 * this.widthOfOneColumn + "px";

    const selectedValueIndicator = this.$refs.selectedValueIndicator;
    selectedValueIndicator.style.width = "" + this.widthOfOneColumn + "px";

    scroller.addEventListener(
      "scroll",
      function (event) {
        that.scrolling = true;
        clearTimeout(that.scrollTimeout);
        that.scrollTimeout = setTimeout(function () {
          that.setValue();
          that.scrolling = false;
        }, 500);
      },
      false
    );
    scroller.addEventListener(
      "touchstart",
      function (event) {
        clearTimeout(that.touchTimeout);
        that.touchTimeout = setTimeout(() => {
          that.touch = true;
        }, 500);
      },
      false
    );
    scroller.addEventListener(
      "touchend",
      function (event) {
        clearTimeout(that.touchTimeout);
        that.touch = false;
      },
      false
    );
    if (this.value) {
      setTimeout(() => {
        this.scrollToValue(this.value);
      }, 2000);
    } else {
      this.setValue();
    }
  },
  methods: {
    setValue() {
      let scroller = this.$refs.scroller;
      let finalValue =
        Math.round(scroller.scrollLeft / this.widthOfOneColumn) *
          this.stepValue +
        this.startNumber;
      finalValue = Math.round(finalValue * 100) / 100;
      this.val = finalValue;
      this.$emit("valueUpdated", this.val);
    },
    scrollToValue(v) {
      clearTimeout(this.scrollTimeout);
      this.setValue();
      let stepsToSkip =
        ((v - this.val) / this.stepValue) * this.widthOfOneColumn;
      const scroller = this.$refs.scroller;
      scroller.scrollBy({
        top: 0,
        left: stepsToSkip,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
p {
  line-height: 30px;
}

#scroller {
  height: 40px;
  /*position: fixed;*/
  border: none;
  background-color: #00000010;
  border-radius: 30px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-snap-stop: always;
}

#scroller::-webkit-scrollbar {
  display: none;
}

#scroller-block {
  overflow: visible;
  display: grid;
}

.numberInScroller {
  text-align: center;
  line-height: 22px;
  height: 30px;
  margin: 0px;
  padding-top: 10px;
  scroll-snap-align: center;
}

#selectedValueIndicator {
  height: 40px;
  border-radius: 50%;
  background-color: transparent;
  border: solid;
  border-width: 1px;
  border-color: #00000050;
  z-index: 0;
  position: relative;
  /*  margin-top: -40px; */
  pointer-events: none;
  box-shadow: inset 0 0 10px #00000050;
  transition: height 0.2s, width 0.2s;
  position: absolute;
}
.selected-indicator {
  height: 80px !important;
  /*   margin-top: -60px !important;
  margin-left: 140px !important; */
  width: 80px !important;
  background-color: white !important;
  display: grid;
  place-items: center;
}
</style>
